import styled from "styled-components";

const Wrapper = styled.div`
  .organizations-error {
    margin-bottom: 16px;
  }
  .toolbar {
    margin-bottom: 16px;
  }

  .table-link {
    padding: 0;
  }

  .form-row {
    display: flex;
  }

  .flex-field {
    flex: 1;
  }

  .tax-input {
    width: 140px;
  }

  .billing-select {
    width: 170px;
  }

  .date-input {
    width: 150px;
  }

  .amount-input {
    width: 180px;
  }
`;

export default Wrapper;
